// Fill states select on homepage
let isHome = document.body.classList.contains('frontpage');

// Rep Locator page
let locatorExists = document.getElementById("locator-state");
let resetExists = document.querySelector('.form-reset');

if(locatorExists && !isHome) {
  repLocator.init({
    brand: 'PB',
    map: document.getElementById('locator-map'),
    worldMap: document.getElementById('locator-world-map'),
    stateInput: document.getElementById('locator-state'),
    stateInputLabel: document.getElementById('locator-state-label'),
    countyInput: document.getElementById('locator-county'),
    countyInputLabel: document.getElementById('locator-county-label'),
    zipInput: document.getElementById('locator-zip'),
    zipInputLabel: document.getElementById('locator-zip-label'),
    resetForm: document.getElementById('form-reset'),
    resultsBox: document.getElementById('locator-results'),
    countryInput: document.getElementById('locator-country'),
    repTemplate: `
    <div class="info">
      <div class="left">
        <div class="contact">{{contact}}</div>
        <div class="numbers">
          <div class="phone">P: <a>{{phone}}</a></div>
        {{#fax}}
          <div class="fax">F: <a>{{fax}}</a></div>
        {{/fax}}
        </div>
        <div class="email"><a href="mailto:{{email}}">{{email}}</a></div>
        {{#principal_email}}
          <div class="contact">{{principal}}</div>
          <div class="email"><a href="mailto:{{principal_email}}">{{principal_email}}</a></div>
        {{/principal_email}}
        <div class="agency">{{agency}}</div>
        <div class="address">{{address}}<br>{{city}}, {{state}} {{zip}}</div>
        <div class="notes">{{notes}}</div>
      </div>
      <div class="right">
        
      </div>
    </div>`
  });
}
